import { createTheme } from "@mui/material/styles";

const colors = {
  seiuPurple: "#664697",
  slateBlue: "#72A3D2",
  white: "#ffffff",
  yellow: "#dfc118",
};

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          marginRight: "1rem",
          "&:last-of-type": {
            marginRight: 0,
          },
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        grouped: {
          marginRight: 0,
        },
      },
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: colors.seiuPurple,
    },
    secondary: {
      main: colors.slateBlue,
      contrastText: colors.white,
    },
    contrast: {
      main: colors.yellow,
      contrastText: colors.white,
    },
  },
  MuiButtonBase: {
    overrides: {
      NoColorChangeOnHover: {
        backgroundColor: "inherit",
        "&:hover": {
          backgroundColor: "inherit !important", // Keep the background color the same on hover
        },
      },
    },
  },
});

export default theme;
